import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { getBackendUrl, LoadStateInfo, loaded, loading, notStarted, error, getImagesUrl, failedResponse, INVALID_ID } from "../common";
import { getToken } from "../../features/user/UserAvatar";
import { RoutineItemOptionInfo } from "./routineItemOptionSlice";

export interface RoutineItemOptionInsUptState {
  state: LoadStateInfo;
  routineItemOption: RoutineItemOptionInfo;
}

const initialState: RoutineItemOptionInsUptState = {
  state: notStarted(),
  routineItemOption: emptyRoutineItemOption(),
};

export function emptyRoutineItemOption(): RoutineItemOptionInfo {
  return {
    id: INVALID_ID,
    routineId: "",
    routineItemId: "",
    name: "",
    url: `${getImagesUrl()}/default/routine.webp`,
  };
}

export interface RoutineItemOptionInsertRequest {
  routineItemOption: RoutineItemOptionInfo;
}
export const routineItemOptionInsert = createAsyncThunk(
  "routineItemOptionInsert",
  async (param: RoutineItemOptionInsertRequest, thunkAPI) => {
    console.debug("insert routine item option");
    const response = await fetch(`${getBackendUrl()}/api/routine-item-option`, {
      method: "POST",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.routineItemOption)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface RoutineItemOptionUpdateRequest {
  routineItemOptionId: string;
  routineItemOption: RoutineItemOptionInfo;
}
export const routineItemOptionUpdate = createAsyncThunk(
  "routineItemOptionUpdate",
  async (param: RoutineItemOptionUpdateRequest, thunkAPI) => {
    console.debug("update routine");
    const response = await fetch(`${getBackendUrl()}/api/routine-item-option/${param.routineItemOptionId}`, {
      method: "PUT",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(param.routineItemOption)
    });
    if(response.ok) {
      return await response.json();
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export interface RoutineItemOptionRemoveRequest {
  routineItemOption: RoutineItemOptionInfo;
}
export const routineItemOptionRemove = createAsyncThunk(
  "routineItemOptionRemove",
  async (param: RoutineItemOptionRemoveRequest, thunkAPI) => {
    console.debug("remove routine item option");
    const response = await fetch(`${getBackendUrl()}/api/routine-item-option/${param.routineItemOption.id}`, {
      method: "DELETE",
      signal: thunkAPI.signal,
      headers: {
        "Authorization": `Bearer ${getToken()}`,
      }
    });
    if(response.ok) {
      return "OK";
    } else {
      return thunkAPI.rejectWithValue(failedResponse( response ));
    }
  }
);

export const routineItemOptionInsUpdSlice = createSlice({
  name: "routineItemInsUpd",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    set: (state, action: PayloadAction<RoutineItemOptionInfo>) => {
      state.state = notStarted();
      state.routineItemOption = action.payload;
    },
    clean: (state) => {
      state.state = notStarted();
      state.routineItemOption = emptyRoutineItemOption();
    }
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(routineItemOptionInsert.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(routineItemOptionInsert.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state = loaded();
        state.routineItemOption = action.payload;
      })
      .addCase(routineItemOptionInsert.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(routineItemOptionUpdate.pending, (state, /* action */) => {
        state.state =  loading();
      })
      .addCase(routineItemOptionUpdate.fulfilled, (state, action) => {
        console.debug(`${action.type}`);
        state.state =  loaded();
        state.routineItemOption = action.payload;
      })
      .addCase(routineItemOptionUpdate.rejected, (state, action) => {
        state.state = error(action);
      })
      .addCase(routineItemOptionRemove.pending, (state, /* action */) => {
        state.state = loading();
      })
      .addCase(routineItemOptionRemove.fulfilled, (state, /* action */) => {
        state.state = loaded();
        state.routineItemOption = emptyRoutineItemOption();
      })
      .addCase(routineItemOptionRemove.rejected, (state, action) => {
        state.state = error(action);
      });
    },
});

// export const { } = routineItemOptionInsUpdSlice.actions;

export const selectRoutineItemOptionInsUpd = (state: RootState) => state.routineItemOptionInsUpd;

export default routineItemOptionInsUpdSlice.reducer;
